import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect } from 'react'
import { Switch, Route } from 'react-router-dom'

import { Auth, useAuth } from 'src/modules/auth'
import { Buyer } from 'src/modules/buyer'
import { useMessages } from 'src/modules/messages'
import { Supplier } from 'src/modules/supplier'
import { Notification, useActionRunner } from 'src/modules/notification'
import { Public } from 'src/modules/public'

import { useApp } from '../hooks'
import AppHeader from './AppHeader'

const useStyles = makeStyles(theme => ({
  content: {
    paddingTop: 57,
    [theme.breakpoints.up('mobile')]: {
      paddingTop: 82,
    },
  },
}))

const App = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Notification />
      <AppHeader />
      <div className={classes.content}>
        <Switch>
          <Route path="/public" component={Public} />
          <Route>
            <Auth>
              <AppAuthed />
            </Auth>
          </Route>
        </Switch>
      </div>
    </div>
  )
}

const AppAuthed = () => {
  const { fetchUnreadNotificationsCount } = useApp()
  const { fetchUnreadConversationsCount } = useMessages()
  const { user, getFeatureSwitches } = useAuth()

  const [doGetFeatureSwitches] = useActionRunner(getFeatureSwitches)

  const fetchNotifications = () =>
    Promise.all([
      fetchUnreadNotificationsCount(),
      fetchUnreadConversationsCount(),
    ])

  useEffect(() => {
    fetchNotifications()
    const timerId = setInterval(fetchNotifications, 5 * 60 * 1000)
    return () => clearInterval(timerId)
  }, [])

  useEffect(() => {
    if (user) {
      doGetFeatureSwitches()
    }
  }, [user])

  if (user.organisation.type === 'buyer') {
    return <Buyer />
  } else if (user.organisation.type === 'supplier') {
    return <Supplier />
  } else {
    return null
  }
}

export default App
